import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header/Header.jsx";
import Footer from "./components/Footer/Footer.jsx";

import Home from "./Pages/Home/Home.jsx";
import AboutUs from "./Pages/AboutUs/AboutUs.jsx";
import MindfulLetoMinds from "./Pages/MindfulLetoMinds/MindfulLetoMinds.jsx";
import Appointment from "./Pages/Appointment/Appointment";
import DoctorReferral from "./Pages/Appointment/DoctorReferral";


import "./App.css";

function App() {
  return (
    <Router>
      {/* <Header /> */}

      <div className="content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/mindful-leto-minds" element={<MindfulLetoMinds />} />
          <Route path="/appointment" element={<Appointment />} />
          <Route path="/appointment_referral" element={<DoctorReferral />} />

        </Routes>
      </div>

      <Footer />
    </Router>
  );
}

export default App;
